import { gql } from '@apollo/client'

export const EXPORT_RESOURCES_QUERY = gql`
  query Resources(
    $first: Int
    $after: String
    $where: ResourceFilterInput
    $order: [ResourceSortInput!]
  ) {
    resources(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        resourceId
        name
        unit
        created
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
